<template>
  <div>
    <div>
      <el-dialog title="过磅记录" center :visible.sync="guoBangVisible" width='80%' :close-on-click-modal="false" :before-close="CKQuXiao">
        <div class="demo-image__preview" >
          <el-table
            min-height="300px"
            max-height="350px"
            size="mini" border
            center bordersize="mini"
            ref="tableList"
            :data="tableList"
            style="width: 100%;font-size:12px;"
            class="elTab">
            <el-table-column prop="grossWeight" label="毛重(吨)" align="center"></el-table-column>
            <el-table-column prop="tareWeight" label="皮重(吨)" align="center" ></el-table-column>
            <el-table-column prop="weightingWeight" label="净重(吨)" align="center" ></el-table-column>
            <el-table-column prop="grossWeightTime" label="毛重过磅时间" align="center" width="160" :formatter="dateTimeFormat"></el-table-column>
            <el-table-column prop="grossWeightOperator" label="毛重司磅员" align="center"></el-table-column>
            <el-table-column prop="tareWeightTime" label="皮重过磅时间" align="center" width="160" :formatter="dateTimeFormat"></el-table-column>
            <el-table-column prop="tareWeightOperator" label="皮重司磅员" align="center"></el-table-column>
            <el-table-column prop="weighSingletonWeight" label="过磅件重（吨/件）" align="center" width="130"></el-table-column>
            <el-table-column prop="estimatedSingletonWeight" label="预报实入件重（吨）" align="center" width="150"></el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="CKQuXiao">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getOutWeightInfo
} from '@/api/wms-access'
import { dateTimeFormat } from '@/utils/util.js'
export default {
  name: 'djDialog',
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      tableList: []
    }
  },
  props: {
    guoBangVisible: {
      type: Boolean,
      default: false
    },
    outstockSummaryId: {
      type: Number
    }
  },
  methods: {
    getOutWeightInfo () {
      this.tableList = []
      getOutWeightInfo(this.outstockSummaryId).then(res => {
        this.tableList.push(res)
      })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    CKQuXiao () {
      this.$emit('update:guoBangVisible', false)
    }
  },
  mounted () {
    console.log(this.outstockSummaryId)
    this.getOutWeightInfo()
  }
}
</script>

<style>

</style>
